import {combine, createEffect, createEvent, createStore} from 'effector';
import {createGate} from 'effector-react';

import {
    CodeValidationParams,
    CodeValidationResponse,
    DashboardDateType,
    DateRange,
    ProductDefectParams,
    ProductDefectRecord,
    ProductDynamicParams,
    ProductDynamicRecord,
    ProductDynamicResponse,
    ProductStatusParams,
    ProductStatusRecord,
    ProductTopParams,
    ProductTopRecord,
} from 'types';
import {dashboardPeriod} from 'utils/dashboardPeriod';

import {PackageTypes} from '../../types/gtins';

export const Gate = createGate();

export const loadProductDynamicStatisticsFx = createEffect<
    ProductDynamicParams,
    ProductDynamicResponse
>();
export const loadProductStatusStatisticsFx = createEffect<
    ProductStatusParams,
    ProductStatusRecord[]
>();

export const loadProductDefectStatisticFx = createEffect<
    ProductDefectParams,
    ProductDefectRecord[]
>();

export const loadProductTopStatisticsFx = createEffect<ProductTopParams, ProductTopRecord[]>();

export const codeValidationFx = createEffect<
    CodeValidationParams | null,
    CodeValidationResponse | null
>();

export const dateTypeChanged = createEvent<DashboardDateType>();
export const dateRangeChanged = createEvent<DateRange>();

export const packageTypeChanged = createEvent<PackageTypes>();

export const resetDates = createEvent();

export const dateType$ = createStore<DashboardDateType>(DashboardDateType.Month);
export const dateRange$ = createStore<DateRange>(dashboardPeriod(DashboardDateType.Month));

export const packageType$ = createStore<PackageTypes>(PackageTypes.UNIT);
export const codeValidationParams$ = createStore<CodeValidationParams | null>(null);

export const productDynamic$ = createStore<ProductDynamicRecord[]>([]);
export const productDynamicTotal$ = createStore<number | null>(null);
export const productStatus$ = createStore<ProductStatusRecord[]>([]);
export const productTop$ = createStore<ProductTopRecord[]>([]);
export const productDefect$ = createStore<ProductDefectRecord[]>([]);

export const codeValidationParamsChanged = createEvent<CodeValidationParams | null>();
export const codeValidation$ = createStore<CodeValidationResponse | null>(null);

export const activeStatusBarChartChanged = createEvent<string | null>();
export const activeStatusBarChart$ = createStore<string | null>(null);

export const activeTopProductCircleChanged = createEvent<string | null>();
export const activeTopProductCircle$ = createStore<string | null>(null);

export const dashboardState$ = combine({
    dateType: dateType$,
    dateRange: dateRange$,
    packageType: packageType$,
    codeValidationParams: codeValidationParams$,
    productDynamic: productDynamic$,
    productDynamicTotal: productDynamicTotal$,
    productDynamicPending: loadProductDynamicStatisticsFx.pending,
    productStatus: productStatus$,
    productStatusPending: loadProductStatusStatisticsFx.pending,
    productTop: productTop$,
    productTopPending: loadProductTopStatisticsFx.pending,
    productDefect: productDefect$,
    productDefectPending: loadProductDefectStatisticFx.pending,
    codeValidation: codeValidation$,
    codeValidationPending: codeValidationFx.pending,
});
